export default __webpack_public_path__ + "static/door_b.e0bb3c5643075ca1509c216a5df5155e.png";